import React, { Fragment, useState, useEffect,useContext,lazy,Suspense } from "react";
import { FormatedPrice,MasterCloudCommandeButton,MasterCloudGiftCardButton,MasterCloudCreateItem,MasterCloudPreparation,OpenCashDrawerBtn,Loading} from "@gull"
import { useTranslate } from 'react-redux-multilingual'
import { Modal,DropdownButton,Dropdown} from "react-bootstrap";
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt,faEdit, faCommentAlt} from '@fortawesome/free-solid-svg-icons'
import swal from "sweetalert2";
import {imprimeCaisseIdent} from 'app/imprimeEtiquette'
import { useCookies} from 'react-cookie';
import { Badge } from "react-bootstrap";
import { PeripheriqueContext,IsAuthContext } from 'app/App';
import ApercuPrixArticleBarre from './ApercuPrixArticleBarre'

const PaymentForm = lazy(() => import('../../../@gull/components/form/PaymentForm/PaymentForm'));
const ReturnArticleModal = lazy(() => import('../../../@gull/components/ReturnArticle/ReturnArticleModal'));
const CreditGiftCardModal = lazy(() => import('../../../@gull/components/modal/CreditGiftCardModal'));
const SearchSalesOrder = lazy(() => import('../../../@gull/components/SearchSalesOrder/SearchSalesOrder'));
const CreateItemFormPos = lazy(() => import('../../../@gull/components/form/CreateItemFormPos'));
const OrderFormNext = lazy(() => import('../../../@gull/components/form/PaymentForm/Component/OrderFormNext'));
const AlertCurrentReceipt = lazy(() => import('../../../@gull/components/alert/AlertCurrentReceipt'));
const MatchBarCodeForm = lazy(() => import('../../../@gull/components/form/MatchBarCodeForm'));
const SearchDevisModal = lazy(() => import('../../../@gull/components/modal/SearchDevisModal'));
const SavedTicketModal = lazy(() => import('../../../@gull/components/modal/SavedTicketModal'));
const EditPriceModal = lazy(() => import('../../../@gull/components/LineItemPos/Component/EditPriceModal'));
const ToPrepareModal = lazy(() => import('../../../@gull/components/modal/ToPrepareModal'));
const GlobalNoteModal = lazy(() => import('../../../@gull/components/modal/GlobalNoteModal'));

const useLoad = (idsLocalStorage,posid) => {
  const t =useTranslate()
  const [caisseIdentName,setCaisseIDentName]=useState(false)

  const [section,setSection]=useState(false)
  const [restrictionAssociate,setRestrictionAssociate]=useState({
      go:true,
      grades:[]
  })
  
  useEffect(function () {
      (async function() {
          const response = await axios.get(process.env.REACT_APP_API_URL+"api/section/"+posid
          ).then((response) => {
              let restriction = response.data.restriction.filter(value=>value.action==='matchBarCodeToItem')
              if(restriction.length>0){
                  if(restriction[0].grade.length > 0){
                      setRestrictionAssociate({
                          go:false,
                          grades: restriction[0].grade.map(value=>value.id)
                      })
                  }
              }
              setSection(response.data)
          }).catch((error) => {
              if(error=='end_session') return;
              swal.fire(t('unknowError'), "", "error");
          })
      })()
  }, [])

  useEffect(function () {
      (async function() {
          const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/pos/get_one_caisse_ident/"+idsLocalStorage[1]
          ).then((response) => {
              setCaisseIDentName(response.data.data.code)
          }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
              messageError='unknowError'
            }
            else if(error.response.status==403){
              messageError='forbiddenGeneral'
            }
            else {
              messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
          })
      })()
  }, [])
  
  return [caisseIdentName,restrictionAssociate,setRestrictionAssociate,section]
}

const FooterPos = (props) =>{
    const t = useTranslate();
    const { peripheriqueParam } = useContext(PeripheriqueContext)
    const { authParam } = useContext(IsAuthContext);
    const [caisseIdentName,restrictionAssociate,setRestrictionAssociate,section] = useLoad(props.idsLocalStorage,props.posid)

    const [orderForm,setOrderForm]=useState(false)
    const [ticketCommande,setTicketCommande]=useState(false)
    const [lastSaleOrder,setLastSaleOrder]=useState(false)
    const [loadLastSaleOrder,setLoadLastCaleOrder]=useState(false)
    const [modalTitle,setModalTitle]=useState('')
    const [isRestriction,setIsRestriction]=useState(false) 
    const [savedTicketList,setSavedTicketList]=useState([])
    const [loadingSavedticket,setLoadingSavedticket]=useState(false)
    const [showEditTotal,setShowEditTotal] = useState(false)
    const [showNote,setShowNote]=useState(false)
    const [afterRestrcitionModifPrice,setAfterRestrcitionModifPrice] = useState(false)
    const [afterRestrictionReturnItem,setAfterRestrictionReturnItem] = useState(false)
    const [ticketEnCours,setTicketEnCours]=useState({
      message:false,
      modal:false
    }) 
    const caissierRequired = (props.modulePos.params.staff.active && !Array.isArray(props.modulePos.params.staff.params) && props.modulePos.params.staff.params.hasOwnProperty('cashier_required') && props.modulePos.params.staff.params.cashier_required) ? true : false

    const getLastSale = async () =>{//l'appel à l'api pour obtenir un ticket sur Pos.jsx sera relancé 
      if(props.cookies.last_ticket){
        if(props.cookies.current_ticket){
          setTicketEnCours({...ticketEnCours, modal:true})
          setModalTitle(t('lastSale'))
        }else{
          props.setLoadingLastTicket(true)
          setTicketEnCours({...ticketEnCours, modal:false})
          props.setCookie("current_ticket",props.cookies.last_ticket,{ path: "/", expires: props.expire_date }) 
          props.setIsLastTicket(true)
          props.setRelanceFocus(Date.now())
        }
      }else{
        swal.fire(t('noPreviousSale'), "", "error"
        ).then((result) => {
          if (result.isConfirmed) {
            props.setRelanceFocus(Date.now())
          } else{
            props.setRelanceFocus(Date.now())
          }
        })
        props.setLoadingLastTicket(false)
      }
    }
    
    const getLastDevis = async () =>{//l'appel à l'api pour obtenir un ticket sur Pos.jsx sera relancé 
      if(props.cookies.last_quotation){
        if(props.cookies.current_ticket){
          setTicketEnCours({...ticketEnCours, modal:true})
          setModalTitle(t('lastQuotation'))
        }else{
          props.setLoadingLastTicket(true)
          setTicketEnCours({...ticketEnCours, modal:false})
          props.setCookie("current_ticket",props.cookies.last_quotation,{ path: "/", expires: props.expire_date }) 
          props.setIsLastTicket(true)
          props.setRelanceFocus(Date.now())
        }
      }else{
        swal.fire(t('noPreviousDevis'), "", "error"
        ).then((result) => {
          if (result.isConfirmed) {
            props.setRelanceFocus(Date.now())
          } else{
            props.setRelanceFocus(Date.now())
          }
        })
        props.setLoadingLastTicket(false)
      }
    }

    const getAllSavedTicket = async () => {
      setLoadingSavedticket(true)
      const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/saved_ticket/get_all_in_section/"+props.posid
      ).then((response) => {
          if(!response.data.valid){
              swal.fire(t('unknowError'), "", "error");
          }
          else{   
              setSavedTicketList(response.data.datas)
          }
      }).catch((error) => {
          if(error=='end_session') return;
          swal.fire(t('unknowError'), "", "error");
      })
      setLoadingSavedticket(false)
    };

    const check_abonnement = () => { // Contrôle si client présent quand abonnement dans le ticket
      if (props.ticketDetail.find(value => value.abonnement)) {
        if (props.currentTicket.client_id!=null) return true;
        else return false;
      }
      else {
        return true;
      }
    }

    const handleClick = (module) =>{
        props.setIsFor(module)
        if(module!='caisseIdTag' && module!='pay')props.setShow(true)
        //Si un ticket est en cours, il ne faut pas qu'on puisse récupérer une commande client ou la dernière vente car cela peut créer des erreurs sur le fond de caisse 
        if(module=='lastSalesOrder' || module=='salesOrder' || module=='devisSearch'){
          if(props.cookies.current_ticket){
            setTicketEnCours({...ticketEnCours, message:true})
          }else{
            setTicketEnCours({...ticketEnCours, message:false})
          }
        }
        switch (module) {
          case 'pay':
            if (props.modulePos.params?.abonnement?.active) { // Si module abonnement
              if (check_abonnement()) { 
                props.setShow(true)
                //ici on affiche le total, on a donc besoin de renseigner
                //le montant total, la raison et la devise 
                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                  // Si on est sur un afficheur simple 2 lignes, on envoie la commande pour afficher le total sur l'afficheur, car sur le type second ecran, total est affiché tout le temps
                  props.affichageClient('',props.totalAchat,'','total',props.devise,t,props.peripheriqueParam)
                }
                setModalTitle(t('btnPay'))
              }
              else { // Si client non renseigné et abonnement dans le ticket
                swal.fire(t('noClientAbonnementcard'), "", "error");
              }
            }
            else {
              props.setShow(true)
              //ici on affiche le total, on a donc besoin de renseigner
              //le montant total, la raison et la devise 
              if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                // Si on est sur un afficheur simple 2 lignes, on envoie la commande pour afficher le total sur l'afficheur, car sur le type second ecran, total est affiché tout le temps
                props.affichageClient('',props.totalAchat,'','total',props.devise,t,props.peripheriqueParam)
              }
              setModalTitle(t('btnPay'))
            }
            break;
          case 'lastSalesOrder':
            setModalTitle(t('salesOrder'))
            if(!props.cookies.current_ticket && props.cookies.last_sale_order){
              setLoadLastCaleOrder(true)
              const test = axios.get(process.env.REACT_APP_API_URL+"api/pos/commande/get_by_id/"+props.cookies.last_sale_order+'/'+props.posid
              ).then((response) => {
                  if(!response.data.valid){
                      let interms='';
                      var keys = Object.keys(response.data.errors);
                      for(var i = 0; i < keys.length; i++){
                          interms+=response.data.errors[keys[i]].join(',')+','
                      }
                      interms=interms.split(',')
                      let messageError='';
                      interms.forEach(interm=>messageError+=t(interm)+'. ')
                      messageError=messageError.replace('undefined','');
                      swal.fire(messageError, "", "error");
                  }else{  
                      if(response.data.data.cancel==1 || response.data.data.ticket.status==1){
                        props.removeCookie('last_sale_order',{ path: "/"})
                        setLastSaleOrder(false)
  
                      }else{
                        setLastSaleOrder(response.data.data)
                      }
                      setLoadLastCaleOrder(false)
                  }
              }).catch((error) => {
                  if(error=='end_session') return;
                  let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                  swal.fire(t(errorName), "", "error");
                  setLoadLastCaleOrder(false)
              })
            }
            break;
          case 'saved':
            setModalTitle(t('receiptSaved'))
            break;
          case 'return':
            setModalTitle(t('itemReturn'))
            break;
          case 'giftcardcredit':
            setModalTitle(t('giftCardCredit'))
            break;
          case 'salesOrder':
            setModalTitle(t('salesOrder'))
            break;
          case 'caisseIdTag':
            imprimeCaisseIdent(props.peripheriqueParam,caisseIdentName,'pos',t)
            break;
          case 'itemCreation':
            setModalTitle(t('itemCreation'))
            break;
          case 'barCodeMatch':
            setModalTitle(t('matchBarCode'))
            break;
          case 'devisSearch':
            setModalTitle(t('devisSearch'))
            break;
          case 'currentCommande':
            setModalTitle(t('salesOrder'))
            break;
          case 'to_prepare':
            setModalTitle(t('btnPrepare'))
            break;
        }
    }

    const closeModal = (module) =>{
      if(Object.keys(props.currentTicket).length!=0 && props.currentTicket.status==1 && module=='onCloseModal'){
        props.setCashierId(false);
        props.setModeService('a_emporter')
        props.setClientId(false);
        props.setValueInputCashier('')  
        props.setValueInputClient('')
        props.setInvalidInput({
            searchCashier: true,
            searchClient: true
        })
        props.removeCookie('current_ticket',{ path: "/"})
        props.setCurrentTicket({})
        props.setDisabledPay(true)
        if(caissierRequired && !props.caissierMemory) props.setRelanceFocusRh(Date.now()) 
      }
      if((Object.keys(props.currentTicket).length!=0 && props.currentTicket.status==1 && module=='onCloseModal') || Object.keys(props.currentTicket).length==0) props.resetSearchRaccourci()
      if(isRestriction) setRestrictionAssociate({...restrictionAssociate,go:false})
      if(afterRestrictionReturnItem){ 
        props.setRestrictionRetourArticle({...props.restrictionRetourArticle,go:false})
        setAfterRestrictionReturnItem(false)
      }
      setOrderForm(false)
      setTicketCommande(false)
      if(!caissierRequired || props.caissierMemory) props.setRelanceFocus(Date.now())
      //Si ticket en cours, non finalisé, on passe btnDisabled à false car en appuyant sur devis, ça passer btnDisabled à truc et si on ferme la modal, tous les bouttons son bloqués 
      if(Object.keys(props.currentTicket).length!=0 && props.currentTicket.status==0)props.setBtnDisabled(false)
      props.setShow(false)
    }

    const closeModalNote = (name) =>{
      if(name == 'note'){
        setShowNote(false)
      }
    }
    
    const callbackEditTotalPrice = () =>{
        setAfterRestrcitionModifPrice(true)
    }

    const closeModalEditTotalPrice= (name) =>{
      setShowEditTotal(false)
      if(afterRestrcitionModifPrice){ 
          props.setRestrictionModifPrix({...props.restrictionModifPrix,go:false})
          setAfterRestrcitionModifPrice(false)
      }
      props.setRelanceFocus(Date.now())
    }

    return(
        <>
        <Modal size="xl" show={props.show} onHide={() => closeModal('onCloseModal')}>
            <Modal.Header >
                <Modal.Title>{
                  <div>
                      {modalTitle}
                      <OpenCashDrawerBtn peripheriqueParam={peripheriqueParam}/>
                  </div>
                }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(props.isFor && props.isFor =='pay') ?
                  <Suspense fallback={<Loading></Loading>}>
                    <PaymentForm 
                      posid={props.posid}
                      currentTicket={props.currentTicket}
                      setCurrentTicket={props.setCurrentTicket}
                      totalAchat={props.totalAchat}
                      cookies={props.cookies}
                      clientId={props.clientId}
                      setCookie={props.setCookie}
                      expire_date={props.expire_date}
                      orderForm={orderForm}
                      setOrderForm={setOrderForm}
                      ticketCommande={ticketCommande}
                      setTicketCommande={setTicketCommande}
                      resetSale={props.resetSale}
                      setModalTitle={setModalTitle}
                      setShow={props.setShow}
                      actualShop={props.actualShop}
                      setRelanceCommande={props.setRelanceCommande}
                      allCommandes={props.allCommandes}
                      setAllCommandes={props.setAllCommandes}
                      modulePos={props.modulePos}
                      restrictionRemoveLinePayment={props.restrictionRemoveLinePayment}
                      setRestrictionRemoveLinePayment={props.setRestrictionRemoveLinePayment}
                      section={props.section}
                      pointsFidelite={props.pointsFidelite}
                      setPointsFidelite={props.setPointsFidelite}
                      clientFideliteInfo={props.clientFideliteInfo}
                      setClientFideliteInfo={props.setClientFideliteInfo}
                      setShowBtnFidelite={props.setShowBtnFidelite}
                      countItems={props.countItems}
                      seuilCashBack={props.seuilCashBack}

                      valueInputClient={props.valueInputClient}
                      setValueInputClient={props.setValueInputClient}
                      setClientId={props.setClientId}
                      affichageClient={props.affichageClient}
                      company={props.company}
                      currentPayment={props.currentPayment}
                      setCurrentPayment={props.setCurrentPayment}
                      btnDisabled={props.btnDisabled}
                      setBtnDisabled={props.setBtnDisabled}
                      padsRefs={props.padsRefs}
                      restrictionRemboursementOther={props.restrictionRemboursementOther}
                      setRestrictionRemboursementOther={props.setRestrictionRemboursementOther}
                      restrictionRemboursementEsp={props.restrictionRemboursementEsp}
                      setRestrictionRemboursementEsp={props.setRestrictionRemboursementEsp}
                      closeModal={closeModal}

                      valeurArrondi={props.valeurArrondi}
                    />
                  </Suspense>
                : 
                  (props.isFor && props.isFor =='return') ?
                    <Suspense fallback={<Loading></Loading>}>
                      <ReturnArticleModal 
                        posid={props.posid}
                        digit={props.digit}
                        devise={props.devise}

                        expire_date={props.expire_date}
                        cookies={props.cookies}
                        setCookie={props.setCookie}
                        setCurrentTicket={props.setCurrentTicket}
                        clientId={props.clientId}
                        cashierId={props.cashierId}
                        affichageClient={props.affichageClient}
                        peripheriqueParam={props.peripheriqueParam}
                        restrictionRetourArticle={props.restrictionRetourArticle}
                        setRestrictionRetourArticle={props.setRestrictionRetourArticle}
                        setAfterRestrictionReturnItem={setAfterRestrictionReturnItem}
                        section={props.section}
                      />
                    </Suspense>
                  :
                    (props.isFor && props.isFor =='giftcardcredit') ?
                      <Suspense fallback={<Loading></Loading>}>
                        <CreditGiftCardModal 
                          posid={props.posid}
                          digit={props.digit}
                          devise={props.devise}
                        />
                      </Suspense>
                    :
                      (props.isFor && props.isFor =='salesOrder') ?
                        <Suspense fallback={<Loading></Loading>}>
                          <SearchSalesOrder   
                            posid={props.posid}
                            digit={props.digit}
                            devise={props.devise}
                            expire_date={props.expire_date}
                            cookies={props.cookies}
                            setCookie={props.setCookie}
                            removeCookie={props.removeCookie}
                            resetSale={props.resetSale}
                            closeModal={closeModal}
                            setIsSalesOrder={props.setIsSalesOrder}
                            setModalTitle={setModalTitle}
                            setShow={props.setShow}
                            ticketEnCours={ticketEnCours}
                            valeurArrondi={props.valeurArrondi}
                          />
                        </Suspense>
                      :
                        (props.isFor && props.isFor =='itemCreation') ?
                          <Suspense fallback={<Loading></Loading>}>
                            <CreateItemFormPos   
                              setShow={props.setShow}
                              expire_date={props.expire_date}
                              cookies={props.cookies}
                              setCookie={props.setCookie}
                              clientId={props.clientId}
                              cashierId={props.cashierId}
                              posid={props.posid}
                              setCurrentTicket={props.setCurrentTicket}
                              setRelanceFocus={props.setRelanceFocus}
                              affichageClient={props.affichageClient}
                              actual_shop={props.actualShop.code}
                              peripheriqueParam={props.peripheriqueParam}
                              devise={props.devise}
                            />
                          </Suspense>
                      :
                        (props.isFor && props.isFor=='lastSalesOrder') ?
                          (loadLastSaleOrder) ?
                            <span className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm mt-2"></div></span>
                          :
                            (lastSaleOrder) ?
                                <Suspense fallback={<Loading></Loading>}>
                                  <OrderFormNext
                                    ticketCommande={lastSaleOrder}
                                    setTicketCommande={setLastSaleOrder}
                                    posid={props.posid}
                                    digit={props.digit}
                                    devise={props.devise}
                                    from='lastSaleOrder'
                                    expire_date={props.expire_date}
                                    cookies={props.cookies}
                                    setCookie={props.setCookie}
                                    removeCookie={props.removeCookie}
                                    resetSale={props.resetSale}
                                    closeModal={closeModal}
                                    setIsSalesOrder={props.setIsSalesOrder}
                                    setModalTitle={setModalTitle}
                                    setShow={props.setShow}
                                    valeurArrondi={props.valeurArrondi}
                                  />
                                </Suspense>
                              :
                                (ticketEnCours.message) ?
                                  <Suspense fallback={<Loading></Loading>}>
                                    <AlertCurrentReceipt /> 
                                  </Suspense>
                                :
                                  false
                        :
                          (props.isFor && props.isFor=='barCodeMatch') ?
                            <Suspense fallback={<Loading></Loading>}>
                              <MatchBarCodeForm
                                restrictionAssociate={restrictionAssociate}
                                setRestrictionAssociate={setRestrictionAssociate}
                                section={section}
                                posid={props.posid}
                                isRestriction={isRestriction}
                                setIsRestriction={setIsRestriction}
                              />
                            </Suspense>
                        :
                          (props.isFor && props.isFor=='devisSearch') ?
                            <Suspense fallback={<Loading></Loading>}>
                              <SearchDevisModal
                                expire_date={props.expire_date}
                                setCookie={props.setCookie}
                                closeModal={closeModal}
                                ticketEnCours={ticketEnCours}
                              />
                            </Suspense>
                          :
                            (props.isFor && props.isFor === 'currentCommande') ?
                            (props.currentTicket && props.currentTicket.commande) ?
                              <Suspense fallback={<Loading></Loading>}>
                                <OrderFormNext
                                  ticketCommande={{ ...props.currentTicket.commande, ticket: props.currentTicket }}
                                  setTicketCommande={() => {}}
                                  posid={props.posid}
                                  digit={props.digit}
                                  devise={props.devise}
                                  from='posCancel'
                                  expire_date={props.expire_date}
                                  cookies={props.cookies}
                                  setCookie={props.setCookie}
                                  removeCookie={props.removeCookie}
                                  resetSale={props.resetSale}
                                  closeModal={closeModal}
                                  setIsSalesOrder={props.setIsSalesOrder}
                                  setModalTitle={setModalTitle}
                                  setShow={props.setShow}
                                  allCommandes={props.allCommandes}
                                  setAllCommandes={props.setAllCommandes}
                                  actualShop={props.actualShop}
                                  valeurArrondi={props.valeurArrondi}
                                />
                              </Suspense>
                            : null
                          :
                            (props.isFor && props.isFor=='to_prepare') ?
                            <Suspense fallback={<Loading></Loading>}>
                              <ToPrepareModal
                                closeModal={closeModal}
                                ticketEnCours={ticketEnCours}
                                currentTicket={props.currentTicket}
                                setCookie={props.setCookie}
                                authParam={authParam}
                                peripheriqueParam={peripheriqueParam}
                                disabledPay={props.disabledPay}
                              />
                            </Suspense>
                          :
                            <Suspense fallback={<Loading></Loading>}>
                              <SavedTicketModal
                                cookies={props.cookies}
                                digit={props.digit}
                                devise={props.devise}
                                saveTicket={props.saveTicket}
                                setCookie={props.setCookie}
                                setCurrentTicket={props.setCurrentTicket}
                                posid={props.posid}
                                expire_date={props.expire_date}
                                closeModal={closeModal}
                                removeCookie={props.removeCookie}
                                savedTicketList={savedTicketList}
                                setSavedTicketList={setSavedTicketList}
                              />
                            </Suspense>
                }
            </Modal.Body>
        </Modal>
        <Modal size="xl" show={ticketEnCours.modal} onHide={() =>  setTicketEnCours({...ticketEnCours, modal:false})}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AlertCurrentReceipt /> 
            </Modal.Body>
        </Modal>
        {(showEditTotal) &&
          <Suspense fallback={<Loading></Loading>}>
            <EditPriceModal 
                title={t('totalPriceEdition')}
                showEditPrice={showEditTotal}
                closeModal={closeModalEditTotalPrice}
                cookies={props.cookies}
                item={{}}
                setCurrentTicket={props.setCurrentTicket}
                setDisabledPay={props.setDisabledPay}
                section={section}
                posid={props.posid}
                restrictionModifPrix={props.restrictionModifPrix}
                setRestrictionModifPrix={props.setRestrictionModifPrix}
                callback={callbackEditTotalPrice}
                module='pos'
                groupId={props.ticketDetail.map(value=>value.id)}
                forGroup={true}
                authParam={authParam}
            />
          </Suspense>
        }
        {(showNote) &&
          <Suspense fallback={<Loading></Loading>}>
            <GlobalNoteModal 
                showNote={showNote}
                closeModal={closeModalNote}
                posid={props.posid}
                cookies={props.cookies}
                currentTicket={props.currentTicket}
                setCurrentTicket={props.setCurrentTicket}
                module='pos'
            />
          </Suspense>
        }
        <Fragment>
          <div className="flex-grow-1"></div>
          <div id="footerPos">
            <div className="row">
              <div className="col-2">
                <h2 className="mb-2 totalPos">
                  Total: 
                  <strong className='totalPos2'>{<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.totalAchat} />}</strong> 
                  <span className="text-primary" style={{fontSize:'0.9rem'}}>&nbsp;<FontAwesomeIcon className="position-absolute pointer" icon={faEdit}  onClick={()=>setShowEditTotal(true)}/></span>
                </h2>
                <h3 className="mb-0 dontRemise">{t('dontRemise')+':'} <strong className='totalPos2'>{<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.totalRemise} />}</strong></h3>
              </div>
              <div className="col-1">
                  <h3 className="mb-0 totalPos d-flex align-items-center">Note&nbsp;<span className="text-primary d-inline-flex align-items-center" style={{fontSize:'0.9rem'}}><FontAwesomeIcon className="position-absolute pointer" icon={faCommentAlt}  onClick={()=>setShowNote(true)}/></span></h3>
              </div>
              <div className="col-2">
                <p className="mt-0 mb-0"><strong>Nbr {t('items')}: <span>{Math.round(props.countItems*100)/100}</span></strong></p>
                <p className="mt-0 mb-0"><strong>Nbr {t('itemReturn')}: <span>{Math.round(props.countItemsReturn*100)/100}</span></strong></p>
                <p className="mt-0 mb-0"><strong>Nbr {t('lines')}: <span>{props.countLines}</span></strong></p>
              </div>
              <div className="col-4 btnFooterPos">
                <button disabled={props.disabledPay} className="btn btn-success" onClick={()=>handleClick('pay')}>{t('btnPay')}</button>
                <DropdownButton
                  drop='up'
                  variant="info"
                  disabled={props.disabledCloudButton}
                  title={(props.loadingLastTicket) ? <div className="spinner-border spinner-border-sm"></div> : <FontAwesomeIcon className="fs-5" icon={faCloudUploadAlt} />}
                  onClick={()=>getAllSavedTicket()}
                >
                  <Dropdown.Item eventKey="1" onClick={()=>props.saveTicket(false)}>{t('btnSave')}</Dropdown.Item>
                  <Dropdown.Item eventKey="2" onClick={()=>handleClick('saved')}>{t('receiptSaved')}&nbsp;&nbsp;<Badge pill className="badge-primary">{loadingSavedticket ? <span className="spinner-border spinner-border-sm" style={{height:'0.7em', width:'0.7em'}}></span> : savedTicketList.length}</Badge></Dropdown.Item>
                  <Dropdown.Item eventKey="3" onClick={()=>getLastSale()}>{t('lastSale')}</Dropdown.Item>
                  <MasterCloudGiftCardButton modulePos={props.modulePos} handleClick={handleClick}/>
                  <MasterCloudCommandeButton actualShop={props.actualShop} modulePos={props.modulePos} handleClick={handleClick}/>
                  <Dropdown.Item eventKey="10" onClick={()=>getLastDevis()}>{t('lastQuotation')}</Dropdown.Item>
                  <Dropdown.Item eventKey="11" onClick={()=>handleClick('devisSearch')}>{t('devisSearch')}</Dropdown.Item>
                  <MasterCloudCreateItem modulePos={props.modulePos} handleClick={handleClick}/>
                  {(caisseIdentName) ? <Dropdown.Item eventKey="8" onClick={()=>handleClick('caisseIdTag')}>{t('printCaisseIdent')}</Dropdown.Item> : false}
                  <Dropdown.Item eventKey="9" onClick={()=>handleClick('barCodeMatch')}>{t('matchBarCode')}</Dropdown.Item>
                  <MasterCloudPreparation modulePos={props.modulePos} handleClick={handleClick}/>
                </DropdownButton>
                <button className="btn btn-warning" onClick={()=>handleClick('return')}>{t('btnReturn')}</button>
                {(props.cookies.current_ticket) &&
                  <button className="btn btn-danger" onClick={()=>props.resetSale('footer')}>{(props.loadResetTicket) ? <div className="spinner-border spinner-border-sm"></div> : (props.isLastTicket) ? t('btnClose') : t('btnCancel')}</button>
                }
              </div>
              <div className="col-3">
                <ApercuPrixArticleBarre devise={props.devise} digit={props.digit} actualShop={props.actualShop}/>
              </div>
            </div>
          </div>
        </Fragment>
      </>
    )

}

export default FooterPos;